import { render, staticRenderFns } from "./EditBlog.vue?vue&type=template&id=63d5fb2e&"
import script from "./EditBlog.vue?vue&type=script&lang=js&"
export * from "./EditBlog.vue?vue&type=script&lang=js&"
import style0 from "./EditBlog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports